<template>
  <div class="tooltip-wrapper">
    <slot></slot>

    <div class="tooltip" tabindex="-1" :class="{ open: opened }" v-click-outside="close">
      <div
        class="tooltip-trigger"
        @click.prevent="toggle"
        @mouseenter.prevent="onHover && open()"
        @mouseleave.prevent="onHover && close()"
      >
        <slot name="trigger">
          <span class="question-icon-holder"> ? </span>
        </slot>
      </div>
      <div class="tooltip-content">
        <slot name="content">{{ text }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: 'tooltip',
  directives: { clickOutside: vClickOutside.directive },
  props: {
    text: String,
    onHover: Boolean,
  },
  data: () => ({
    opened: false,
  }),
  methods: {
    toggle() {
      this.opened = !this.opened
    },
    open() {
      this.opened = true
    },
    close() {
      this.opened = false
    },
  },
}
</script>

<style lang="scss">
.tooltip-wrapper {
  position: relative;
  margin-bottom: 8px;
  input {
    margin-bottom: 0 !important;
  }
}

.tooltip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  display: inline-flex;
  outline: none;
  margin-left: 6px;

  @include mobile {
    display: inline;
  }

  .tooltip-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    vertical-align: middle;
    outline: none !important;

    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(204, 215, 230, 0.1);
    box-sizing: border-box;
    transition: all 0.25s;

    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: $dark;

    &:hover {
      opacity: 0.75;
    }

    .question-icon-holder {
      display: flex;

      path {
        transition: 250ms;
      }
    }
  }

  .tooltip-content {
    display: none;
    position: absolute;
    left: -24px;
    z-index: 5;
    justify-content: center;
    align-items: center;
    width: max-content;
    min-height: 40px;
    max-width: 310px;
    margin-top: 8px;
    background: $white;
    box-sizing: border-box;
    box-shadow: 0px 20px 75px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    font-size: 14px;
    line-height: 147.5%;
    text-align: left;

    @include mobile {
      position: relative;
      box-shadow: none;
      width: 100%;
      max-width: unset;
      border-radius: 3px;
      border: none;

      padding: 0;
    }

    @include PC {
      bottom: 100%;
      margin: 0 0 12px 0;
      transform: translateY(calc(-25% + 10px));
      filter: drop-shadow(0px 3px 32px rgba(5, 47, 95, 0.02)) drop-shadow(0px 2px 24px rgba(5, 47, 95, 0.02))
        drop-shadow(0px 1px 8px rgba(5, 47, 95, 0.03)) drop-shadow(0px 1px 2px rgba(5, 47, 95, 0.04));

      &::after {
        content: url('~@/assets/icons/arrow-tootlip.svg');
        position: absolute;
        left: 23px;
        top: 100%;
        transform: translateY(-6px);
      }
    }

    @media (max-width: 375px) {
      right: 0;
    }
  }

  &.open {
    .tooltip-trigger {
      background: $gray;
      //transform: rotate(180deg);
    }

    .tooltip-content {
      display: flex;
      padding: 8px 12px;
    }
  }
}
</style>
